// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubHeader_wrapper__eKWi3","content":"SubHeader_content__1XhuC","btnBack":"SubHeader_btnBack__2HDCv","line":"SubHeader_line__qh4A5"};